import { useState } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { api, errMsg } from "../lib/api";
import { PageHeader, Section, Field } from "../components/bits";

const CATS = [["planning", "Affectations et planning"], ["remplacements", "Remplacements"], ["missions", "Missions"], ["disponibilites", "Rappels de disponibilités"], ["messages", "Messages des missions"]];

function Prefs() {
  const { user, reloadMe } = useApp();
  const prefs = user.notif_prefs || {};
  const toggle = async (k) => {
    try { await api.put("/auth/notif-prefs", { prefs: { ...prefs, [k]: prefs[k] === false } }); await reloadMe(); toast.success("Préférence enregistrée"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="card divide-y divide-slate-100" data-testid="notif-prefs">
      {CATS.map(([k, l]) => (
        <button key={k} onClick={() => toggle(k)} className="flex min-h-[52px] w-full items-center justify-between px-4 text-left" data-testid={`pref-${k}`}>
          <span className="font-semibold">{l}</span>
          <span className={`rounded-full px-3 py-1 text-xs font-bold ${prefs[k] === false ? "bg-slate-100 text-slate-500" : "bg-emerald-100 text-emerald-700"}`}>{prefs[k] === false ? "Non" : "Oui"}</span>
        </button>
      ))}
    </div>
  );
}

function DeleteAccount() {
  const { setMe } = useApp();
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const del = async () => {
    if (!window.confirm("Supprimer définitivement votre compte et vos données ?")) return;
    try { await api.post("/auth/delete-account", { password: pwd }); setMe(false); nav("/login"); toast.success("Compte supprimé"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="card space-y-3 p-4">
      <input type="password" className="field" placeholder="Mot de passe pour confirmer" value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="delete-account-pw-input" />
      <button className="btn-danger w-full" disabled={!pwd} onClick={del} data-testid="delete-account-btn">Supprimer mon compte</button>
    </div>
  );
}

export default function Account() {
  const { user, reloadMe } = useApp();
  const [p, setP] = useState({ first_name: user.first_name, last_name: user.last_name, phone: user.phone || "" });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const saveProfile = async (e) => {
    e.preventDefault();
    try { await api.put("/auth/profile", p); await reloadMe(); toast.success("Profil enregistré"); } catch (err) { toast.error(errMsg(err)); }
  };
  const savePw = async (e) => {
    e.preventDefault();
    try { await api.put("/auth/password", pw); setPw({ current_password: "", new_password: "" }); toast.success("Mot de passe modifié"); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div data-testid="account-page">
      <PageHeader title="Mon compte" back="/" />
      <Section title="Informations">
        <form onSubmit={saveProfile} className="card space-y-3 p-4">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Prénom"><input className="field" value={p.first_name} onChange={(e) => setP({ ...p, first_name: e.target.value })} data-testid="account-first-input" /></Field>
            <Field label="Nom"><input className="field" value={p.last_name} onChange={(e) => setP({ ...p, last_name: e.target.value })} data-testid="account-last-input" /></Field>
          </div>
          <Field label="Téléphone"><input className="field" type="tel" value={p.phone} onChange={(e) => setP({ ...p, phone: e.target.value })} data-testid="account-phone-input" /></Field>
          <button className="btn-primary w-full" data-testid="account-save-btn">Enregistrer</button>
        </form>
      </Section>
      <Section title="Mot de passe">
        <form onSubmit={savePw} className="card space-y-3 p-4">
          <Field label="Mot de passe actuel"><input type="password" className="field" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} data-testid="account-current-pw-input" /></Field>
          <Field label="Nouveau mot de passe"><input type="password" minLength={8} className="field" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="account-new-pw-input" /></Field>
          <button className="btn-soft w-full" data-testid="account-pw-save-btn">Modifier</button>
        </form>
      </Section>
      <Section title="Notifications par catégorie"><Prefs /></Section>
      <Section title="Mes données">
        <a href="/recap" className="btn-ghost mb-3 w-full" data-testid="account-export-link">Exporter mon récapitulatif</a>
        <DeleteAccount />
      </Section>
    </div>
  );
}
